import { render, staticRenderFns } from "./ChatFilter.vue?vue&type=template&id=7515a100&scoped=true&"
import script from "./ChatFilter.vue?vue&type=script&lang=js&"
export * from "./ChatFilter.vue?vue&type=script&lang=js&"
import style0 from "./ChatFilter.vue?vue&type=style&index=0&id=7515a100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515a100",
  null
  
)

export default component.exports